import { useEffect, useState } from 'react';

/** Breakpoints, kept in step with the Tailwind classes used in the shell. */
export const COMPACT_QUERY = '(max-width: 1023px)';
export const PHONE_QUERY = '(max-width: 639px)';

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** True below the desktop breakpoint — the side panels become overlay drawers. */
export function useIsCompact() {
  return useMediaQuery(COMPACT_QUERY);
}

/** True on phone-sized screens, where the bottom bar replaces the status bar. */
export function useIsPhone() {
  return useMediaQuery(PHONE_QUERY);
}
